import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import B2BDashboardItem from './b2b-dashboard-item';
import DefaultPieChart from '../../../shared/default-pie-chart/components/default-pie-chart';
import dashboardConstants from '../constants/dashboard-constants';
import { getSummary } from '../actions/dashboard-actions';

class B2BDashboard extends Component {
  componentDidMount() {
    const { getSummary } = this.props;

    getSummary();
  }

  getValue(item, summaryData) {
    return summaryData[item.field] ? summaryData[item.field] : 0;
  }

  formatSummaryData(summaryData) {
    if (summaryData) {
      return dashboardConstants.b2b_dashboard_items.map(item => {
        return { ...item, value: this.getValue(item, summaryData) };
      });
    } else return [];
  }

  renderDashboardItems(items) {
    if (items && items.length > 0) {
      return items.map((item, index) => {
        return <B2BDashboardItem {...item} key={index} />;
      });
    } else return null;
  }

  render() {
    const { summaryData } = this.props;
    const formattedData = this.formatSummaryData(summaryData);
    const registrationChartData = _.filter(formattedData, { is_register_chart: true });
    const cashierChartData = _.filter(formattedData, { is_cashier_chart: true });
    const tradeChartData = _.filter(formattedData, { is_trade_chart: true });

    return (
      <div className="b2b-dashboard-container">
        <div className="row p-l-15 p-r-15">
          {this.renderDashboardItems(formattedData)}
        </div>
        <div className="row">
          <DefaultPieChart title={'B2B_DASHBOARD.REGISTERED_USERS'} customClass={'col-md-4'} data={registrationChartData} showLegend={true} />
          <DefaultPieChart title={'B2B_DASHBOARD.DEPOSIT_WITHDRAWAL'} customClass={'col-md-4'} data={cashierChartData} showLegend={true} />
          <DefaultPieChart title={'B2B_DASHBOARD.TRADES_CHART'} customClass={'col-md-4'} data={tradeChartData} showLegend={true} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  summaryData: state.dashboardReducer.summaryData,
});

const mapDispatchToProps = dispatch => ({
  getSummary: () => {
    dispatch(getSummary());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(B2BDashboard);



// WEBPACK FOOTER //
// ./src/app/main/dashboard/components/b2b-dashboard.js